// auth.guard.ts
import { CanActivateFn, Router, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { inject } from '@angular/core';
import { AuthService } from './auth.service';
import { DeeplinkService } from './deeplink.service';

export const AuthGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree => {
  const authService = inject(AuthService);
  const router = inject(Router);
  const deeplinkService = inject(DeeplinkService);

  // Check if there's a deep link context that allows anonymous access
  if (deeplinkService.shouldSkipAuth(state.url)) {
    return true;
  }

  if (!authService.isAuthenticated()) {
    // Store the intended route for redirect after login
    sessionStorage.setItem('returnUrl', state.url);
    // Use createUrlTree instead of navigate to avoid conflicts
    return router.createUrlTree(['/login']);
  }
  return true;
};
